import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Biggen } from "../directives/biggen";
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-ron-wyatt',
  imports: [Biggen, Link],
  templateUrl: './ron-wyatt.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ron-wyatt.scss',
})
export class RonWyatt {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Ron Wyatt`);
    this.dynamicTitle.description(`Ron Wyatt was an peudo-archaeologist who claimed to have discovered various biblical artifacts and there is no credible evidence to support his findings.`);
  }
}
